import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Spinner
} from "reactstrap";
import { getAllTutorials } from "store/actions/tutorialsAction";
import { getEductions } from "store/actions/blogActions";

const Tutorials = () => {
  const dispatch = useDispatch();
  const { allTutorials } = useSelector((state) => state.tutorial);
  const { EductionVideos } = useSelector((state) => state.blog);
  
  const [eduLoader, setEduLoader] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    dispatch(getAllTutorials());
    dispatch(
      getEductions(() => {
        setEduLoader(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Banner */}
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              TUTORIALS & EDUCATION
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              FHP Academy & Video Guides
            </h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
              Learn how to navigate and master the FansHelpPlayers platform with our comprehensive video guides.
            </p>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            {/* Section 1: Video Tutorials */}
            <Card className="shadow-sm border-0 rounded-4 p-4 bg-white mb-4">
              <p
                className="text-dark auth-desc-title m-0 p-0 font-weight-bold"
                style={{ fontSize: isSmallScreen ? "16px" : "24px" }}
              >
                FHP Brand Video Tutorials
              </p>
              <h3
                className="text-muted mb-4 mt-1"
                style={{ fontSize: isSmallScreen ? "12px" : "16px" }}
              >
                FansHelpPlayers.com
              </h3>

              {!allTutorials ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : allTutorials.length === 0 ? (
                <p className="text-muted text-center py-4">No video tutorials available.</p>
              ) : (
                allTutorials.map((ele, index) => (
                  <Row className="p-0 m-0 align-items-center mb-3" key={index + 100}>
                    <Col md={12} lg={10} className="p-0 m-0">
                      <Row className="align-items-center p-0 m-0">
                        <Col
                          md={10}
                          xs={9}
                          className="p-0 m-0"
                          style={{ wordBreak: "break-all" }}
                        >
                          <h4 className="text-dark font-weight-700 mb-1">
                            {index + 1}. {ele?.title}
                          </h4>
                          <a href={ele?.url} target="_blank" rel="noopener noreferrer" className="text-primary font-weight-500">
                            {ele?.url}
                          </a>
                        </Col>
                        <Col md={2} xs={3} className="p-0 m-0 pl-lg-4 text-right">
                          <a href={ele?.url} target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-danger rounded-circle p-3">
                              <i className="fas fa-play"></i>
                            </button>
                          </a>
                        </Col>
                      </Row>
                      <div
                        className="my-3"
                        style={{
                          borderTop: "1px dashed #e2e8f0"
                        }}
                      ></div>
                    </Col>
                  </Row>
                ))
              )}
            </Card>

            {/* Section 2: Platform Education */}
            <div className="mt-4">
              <h3 className="text-dark font-weight-700 mb-3 ml-2" style={{ fontSize: "20px" }}>
                Platform Education & Resources
              </h3>
              {eduLoader ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : !EductionVideos || EductionVideos.length === 0 ? (
                <Card className="shadow-sm border-0 rounded-4 p-4 bg-white text-center">
                  <p className="text-muted py-4">No education videos available.</p>
                </Card>
              ) : (
                <Row className="d-flex align-items-stretch">
                  {EductionVideos.map((e, index) => (
                    <Col md="6" lg="4" key={index} className="mb-4">
                      <Card className="shadow-sm border-0 rounded-4 h-100 bg-white">
                        <CardBody className="p-4 d-flex flex-column justify-content-between">
                          <div>
                            <div className="d-flex align-items-center mb-3">
                              <span 
                                className="d-flex align-items-center justify-content-center rounded-circle mr-3"
                                style={{ 
                                  width: "40px", 
                                  height: "40px", 
                                  backgroundColor: "#eef2ff", 
                                  color: "#5e72e4" 
                                }}
                              >
                                <i className="fas fa-video" style={{ fontSize: "15px" }}></i>
                              </span>
                              <span className="text-muted font-weight-700" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                                TUTORIAL #{index + 1}
                              </span>
                            </div>
                            
                            <h4 className="text-dark font-weight-700 mb-4 h5" style={{ lineHeight: "1.4", minHeight: "44px" }}>
                              {e.title}
                            </h4>
                          </div>

                          <div>
                            <a
                              href={e.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button 
                                color="outline-primary" 
                                className="w-100 rounded-pill font-weight-bold"
                              >
                                <i className="fas fa-play mr-2"></i> Watch Tutorial
                              </Button>
                            </a>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Tutorials;
